import axiosClient from "@api/axios";

const getUserProfile = () => {
  return axiosClient.get(`/v1/user/profile`);
}

const checkUserExistsBy = async (params) => {
  const payload = {
    ...(params.email && { email: params.email }),
    ...(params.role && { role: params.role })
  };
  const response = await axiosClient.post('/v1/user/check-existed-by', payload)

  return response;
};

const deleteUser = async (userCode, forceDelete = false) => {
  try {
    return await axiosClient.delete(`/v1/user/delete`, {
      data: {
        code: userCode,
        forceDelete: forceDelete
      }
    });
  } catch (error) {
    throw error;
  }
};

export {
  getUserProfile,
  checkUserExistsBy,
  deleteUser
}